import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isObject from 'lodash/isObject';
import { DEFAULT_AUTO_SCROLL_INTERVAL, SHOW_INDICATORS_THRESHOLD } from './constants';
import useResponsive from '../../../../../hooks/use-responsive';
import { toArray } from '../../../../../services/components';
export function getAutoScrollInterval(autoScroll) {
  if (!_isObject(autoScroll) && !autoScroll) {
    return null;
  }
  if (!_isObject(autoScroll) && autoScroll) {
    return DEFAULT_AUTO_SCROLL_INTERVAL;
  }
  var interval = autoScroll.interval;
  return interval;
}
export function getPageSize(items, size, responsive) {
  var mobile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var displayAllMobile = mobile.displayAll,
    mobileSize = mobile.size;
  var _useResponsive = useResponsive(),
    isMobile = _useResponsive.isMobile,
    isTablet = _useResponsive.isTablet;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  if (isMobile) {
    if (!_isNil(mobileSize) && _isNumber(mobileSize)) {
      return Math.min(mobileSize, itemsLength);
    }
  }
  if (responsive) {
    if (isMobile) {
      return displayAllMobile ? itemsLength : 1;
    }
    if (isTablet) {
      return Math.min(2, size, itemsLength);
    }
  }
  return Math.min(itemsLength, size);
}
export function getStepSize(items, size, stepSize) {
  var grouping = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  if (_isNil(stepSize) && grouping === 1) {
    return null;
  }
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  var pageSize = Math.min(size, itemsLength);
  if (_isNil(stepSize)) {
    return pageSize;
  }
  return Math.min(stepSize, pageSize);
}
export function showIndicators(pageSize, items) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? SHOW_INDICATORS_THRESHOLD : _ref$threshold;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  return itemsLength / pageSize < threshold;
}
export function displayCarouselControls(pageSize, items) {
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  return itemsLength > pageSize;
}
export function getElementKey() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = element.key,
    _element$props = element.props,
    props = _element$props === void 0 ? {} : _element$props;
  var _ref2 = props || {},
    children = _ref2.children;
  if (!_isEmpty(key)) {
    return key;
  }
  if (!_isEmpty(children)) {
    if (children.key) {
      return children.key;
    }
    if (_isArray(children)) {
      var childrenKey = children.map(function (_ref3) {
        var k = _ref3.key;
        return k;
      }).filter(Boolean);
      if (!_isEmpty(childrenKey)) {
        return childrenKey.join('_');
      }
    }
  }
  return JSON.stringify(element);
}